export const BASE_SCAN_WAVE = '/api/v1/scanwave';
export const LATEST_SCAN_WAVE = (scanWaveId?: string) =>
  `/api/v1/scanwave/latest${scanWaveId ? `?scanWaveId=${scanWaveId}` : ''}`;
export const CLOSE_CURRENT_SCAN_WAVE = '/api/v1/scanwave/close-current';
export const ALL_SCAN_WAVES = '/api/v1/scanwave';
